// removed by extract-text-webpack-plugin
module.exports = {"fade":"_1Ak4Mxk","isAndroid":"oKBSAEs","isIos":"_1f8FALW","fade__entered":"_1nheg_4","fade__entering":"_1kv7c7T","fade__exited":"Glsad_N","fade__exiting":"_20ztZF3"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Modal/Fade.css
// module id = ./template/components/Modal/Fade.css
// module chunks = client.sitechrome